import { render, staticRenderFns } from "./ListProfileField.vue?vue&type=template&id=99b12cc0&scoped=true"
import script from "./ListProfileField.vue?vue&type=script&lang=js"
export * from "./ListProfileField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b12cc0",
  null
  
)

export default component.exports